import customHeaders, { getSpace } from '../../../common/headers';
import { useState, useEffect } from 'react';
import { KonstantinFeedbackHttps } from './../../../fetchUrls';
import {
  fetchFeedbacksBrandFilter,
  fetchFeedbacksCategoryFilter,
} from '../../../common/filtersFunc';
import {
  DropDownSelector,
  ButtonBasic,
  TextareaDynamicPlaceholder,
} from '@lk-gtcom/ecomlab-components';
import useGeneralStore from '../../../store/general';
import './ModalScenarioSettings.scss';
import { StepItem } from '../../StepItem/StepItem';
import { periodWeek } from '../../../common/constant';
import { ModalComponent } from '../ModalComponent/ModalComponent';

const ModalScenarioSettings = ({
  setIsModal,
  selectedCategoryProperties,
  setSelectedCategoryProperties,
  page
}) => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const [date, setDate] = useState(periodWeek());
  const [dateFrom, dateTo] = date;

  const [ruleId, setRuleId] = useState(selectedCategoryProperties?.ruleId);
  const [categoryId, setCategoryId] = useState(selectedCategoryProperties?.id);

  const [apiData, setApiData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);

  const [selectedApi, setSelectedApi] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState([]);

  const [totalApi, setTotalApi] = useState(0);
  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0);

  const [apiPage, setApiPage] = useState(1);
  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);

  const [apiQuery, setApiQuery] = useState('');
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');

  const [stopWordList, setStopWordList] = useState([]);
  const [stopWordListValue, setStopWordListValue] = useState([]);
  const [err, setErr] = useState(false)

  const changeRuleCat = () => {
    setErr(false)

    let url = `${KonstantinFeedbackHttps}/${page}/category-rules/${ruleId}/categories/${categoryId}`

    const body = JSON.stringify({
      ...selectedCategoryProperties,
      stop_category_id_list: selectedCategory,
      stop_brand_id_list: selectedBrand,
      stop_word_list: stopWordList,
    });

    fetch(url, { body, method: 'PUT', headers })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        setIsModal(false);
        setSelectedCategoryProperties({});
      })
      .catch((err) => {
        setErr(true)
        console.error(err);
      });
  };

  const fetchRuleCat = () => {
    let url = `${KonstantinFeedbackHttps}/${page}/category-rules/${ruleId}/categories/${categoryId}`

    fetch(url, { method: 'GET', headers })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        const { stop_category_id_list, stop_brand_id_list, stop_word_list } =
          json;
        setSelectedCategory(stop_category_id_list);
        setSelectedBrand(stop_brand_id_list);
        setStopWordListValue(stop_word_list);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    fetchRuleCat();
  }, [selectedSpace]);

  useEffect(() => {
    fetchFeedbacksCategoryFilter({
      selectedSpace: selectedSpace?.value,
      page: categoryPage,
      apiData,
      dateFrom,
      dateTo,
      selectedApi,
      pageValue: 'feedbacks',
      selectedBrand,
      selectedCategory,
      setCategoryData: (e) => setCategoryData(e),
      searchParam: categoryQuery,
      setTotal: setTotalCategory
    });
  }, [
    selectedSpace,
    apiData,
    dateFrom,
    dateTo,
    selectedApi,
    selectedBrand,
    categoryPage,
    categoryQuery,
  ]);

  useEffect(() => {
    fetchFeedbacksBrandFilter({
      selectedSpace: selectedSpace?.value,
      page: brandPage,
      apiData,
      categoryData,
      selectedCategory,
      pageValue: 'feedbacks',
      selectedBrand,
      selectedApi,
      dateFrom,
      dateTo,
      searchParam: brandQuery,
      setBrandData: (e) => setBrandData(e),
      setTotal: setTotalBrand
    });
  }, [
    selectedSpace,
    categoryData,
    selectedApi,
    selectedCategory,
    selectedBrand,
    brandPage,
    brandQuery,
  ]);

  return (
    <ModalComponent
      onClose={e => setIsModal(false)}
      title='Настройки работы сценариев'
      right
      child={
        <div className="modal-scenario-settings">
          <div className="modal-scenario-settings__content">

            <StepItem
              title='Если стоп слова/категории/бренды встречаются в отзыве , 
              то ответ автоматически попадает в ручной режим проверки'
            />

            {err && <p className="modal-scenario-settings__text_err">Что-то пошло не так</p>}

            <DropDownSelector
              state={selectedCategory}
              options_prop={categoryData}
              setState={setSelectedCategory}
              placeholder="Стоп категории"
              total={totalCategory}
              fetchCallback={setCategoryPage}
              setInputChange={setCategoryQuery}
              multi
            />

            <DropDownSelector
              state={selectedBrand}
              options_prop={brandData}
              setState={setSelectedBrand}
              fetchCallback={setBrandPage}
              setInputChange={setBrandQuery}
              placeholder="Стоп бренды"
              total={totalBrand}
              multi
            />

            <TextareaDynamicPlaceholder
              width="100%"
              changeValue={stopWordListValue?.join(',')}
              placeholder='Стоп слова'
              tooltip="Введите слова списком через запятую"
              onChange={(e) => setStopWordList(e?.split(','))}
            />
          </div>

          <ButtonBasic
            green
            size="56px"
            width="237px"
            text="Сохранить"
            style={{ marginTop: 'auto' }}
            onClick={changeRuleCat}
          />
        </div>
      }
    />
  );
};

export { ModalScenarioSettings };
